module.exports = __webpack_public_path__ + "pc-top-assets/img/instagram.bdae4cbb.png";